import { useQuery } from '@tanstack/react-query'

import { getDataAccessRequestsVerification } from 'services/data-access-requests'
import {
  DataAccessRequestQueryOptions,
  withDataAccessRequestsEnabled
} from 'services/data-access-requests/hooks/withDataAccessRequestsEnabled'
import { DataAccessRequestQueryKeys } from 'services/data-access-requests/queryKeys'
import type {
  GetDataAccessRequestsVerificationParams,
  GetDataAccessRequestsVerificationResponse
} from 'services/data-access-requests/types'

export const useGetDataAccessRequestsVerification = (
  params: GetDataAccessRequestsVerificationParams,
  options?: DataAccessRequestQueryOptions<GetDataAccessRequestsVerificationResponse, Error>
) => {
  return useQuery<GetDataAccessRequestsVerificationResponse, Error>({
    ...options,
    queryKey: DataAccessRequestQueryKeys.VerificationList(params),
    queryFn: ({ signal }) => getDataAccessRequestsVerification(params, { signal }),
    enabled: withDataAccessRequestsEnabled(options?.enabled ?? true)
  })
}
